import React from "react";
import {
  Box,
  Chip,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

// const toLocal = (value) => {
//   if (!value) return "--";
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return "--";
//   return date.toLocaleString();
// };

const toLocal = (value) => {
  if (!value) return "--";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "--";

  const updatedDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));

  return updatedDate.toLocaleString();
};

const resolveStatusTone = (status) => {
  const code = String(status || "").toUpperCase();
  if (["INSTALLED", "COMPLETED", "SUCCESS"].includes(code)) {
    return { label: code || "INSTALLED", color: "#166534", bg: "#ECFDF3" };
  }
  if (["FAILED", "ERROR", "ROLLED_BACK"].includes(code)) {
    return { label: code, color: "#B91C1C", bg: "#FEF2F2" };
  }
  if (!code) {
    return { label: "--", color: "#475569", bg: "#F1F5F9" };
  }
  return { label: code, color: "#92400E", bg: "#FFFBEB" };
};

export default function FirmwareUpdateHistory({ rows = [], loading = false }) {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 2,
        border: "1px solid rgba(226,232,240,0.95)",
        borderRadius: 4,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.2,
          borderBottom: "1px solid rgba(226,232,240,0.95)",
          background: "linear-gradient(180deg, #F8FAFC, #F1F5F9)",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#0F172A" }}>
          Firmware Update History
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ p: 2 }}>
          <Skeleton height={34} />
          <Skeleton height={34} />
          <Skeleton height={34} />
        </Box>
      ) : rows.length === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography sx={{ color: "#64748B" }}>
            No firmware history available for this device yet.
          </Typography>
        </Box>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow sx={{ background: "#FCFDFE" }}>
              <TableCell sx={{ fontWeight: 700 }}>When</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Firmware</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>From</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>To</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(0, 20).map((row, index) => {
              const tone = resolveStatusTone(row?.status);
              return (
                <TableRow key={row?.status_id || row?.id || `${row?.created_at}-${index}`}>
                  <TableCell>{toLocal(row?.created_at || row?.updated_at)}</TableCell>
                  <TableCell>
                    {(row?.firmware_name || "Firmware") +
                      " · v" +
                      (row?.firmware_version || row?.to_version || "--")}
                  </TableCell>
                  <TableCell>{row?.from_version || "--"}</TableCell>
                  <TableCell>{row?.to_version || "--"}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={tone.label}
                      sx={{
                        color: tone.color,
                        backgroundColor: tone.bg,
                        fontWeight: 700,
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
